import type { Middleware } from '@arcubase/client-ts'
import { notifyKioskVersion, isWatchingKioskVersion } from '@/utils/kioskVersionWatcher'

/**
 * Kiosk 版本检测中间件
 * 检查所有响应中的 X-Kiosk-Version 头，并自动触发版本更新检查
 */
export const kioskVersionCheckMiddleware: Middleware = async (context, next) => {
  const result = await next()
  
  // === RESPONSE 阶段 (next() 之后) ===
  const { response } = context
  // 只有在启动了版本监听时才进行检查
  if (!isWatchingKioskVersion()) {
    return result
  }

  // 检查响应头中的版本信息
  const serverVersion = response?.headers?.['x-kiosk-version']
  if (serverVersion) {
    const versionNumber = parseInt(serverVersion, 10)
    if (!isNaN(versionNumber)) {
      notifyKioskVersion(versionNumber)
    }
  }
  
  return result
}